'use client'

import React, { Fragment } from 'react'

import { HeroBlockComponent } from './HeroBlockComponent'
import { CoursesGridBlockComponent } from './CoursesGridBlockComponent'
import { AboutBenefitsBlockComponent } from './AboutBenefitsBlockComponent'
import { BlogGridBlockComponent } from './BlogGridBlockComponent'

type HomePageBlock =
  | ({ blockType: 'hero' } & Record<string, any>)
  | ({ blockType: 'coursesGrid' } & Record<string, any>)
  | ({ blockType: 'aboutBenefits' } & Record<string, any>)
  | ({ blockType: 'blogGrid' } & Record<string, any>)

type Props = {
  blocks: HomePageBlock[]
}

export const RenderHomeBlocks: React.FC<Props> = ({ blocks }) => {
  if (!blocks || !blocks.length) return null

  return (
    <Fragment>
      {blocks.map((block, index) => {
        const { blockType } = block
        const key = block.id ?? `block-${index}`

        switch (blockType) {
          case 'hero':
            return <HeroBlockComponent key={key} {...block} />
          case 'coursesGrid':
            return <CoursesGridBlockComponent key={key} {...block} />
          case 'aboutBenefits':
            return <AboutBenefitsBlockComponent key={key} {...block} />
          case 'blogGrid':
            return <BlogGridBlockComponent key={key} {...block} />
          default:
            return null
        }
      })}
    </Fragment>
  )
}
